<script setup lang="ts">
import type { Schemas } from "#shopware";

const { resolvePath } = useNavigationSearch();
const { search } = useProductSearch();
const route = useRoute();
const routePath = route.path;

const { data: seoResult } = await useAsyncData("cmsResponse" + routePath, async () => {
	// For client links if the history state contains seo url information we can omit the api call
	if (import.meta.client) {
		if (history.state?.routeName) {
			return {
				routeName: history.state?.routeName,
				foreignKey: history.state?.foreignKey
			};
		}
	}
	const seoUrl = await resolvePath(routePath);
	return seoUrl;
});

if (!seoResult.value?.foreignKey) {
	console.error("product/[slug].vue:", `No data found in API for ${routePath}`);

	throw createError({
		statusCode: 404,
		statusMessage: `No data fetched from API for ${routePath}`
	});
}

const { foreignKey: productId } = useNavigationContext(seoResult as Ref<Schemas["SeoUrl"]>);

const { data: productResponse } = await useCachedAsyncData(`shopware:product:${productId.value}`, () =>
	search(productId.value, {
		criteria: {
			includes: {
				product_cross_selling: ["id", "name", "translated.name"]
			},
			associations: {
				crossSellings: {
					limit: 1,
					filter: [
						{
							type: "equals",
							field: "active",
							value: true
						}
					]
				},
				seoUrls: {},
				media: {},
				options: {},
				properties: {
					associations: {
						group: {}
					}
				},
				allergens: {}
			}
		}
	})
);

if (!productResponse.value) {
	throw createError({ statusCode: 404, fatal: true, message: `Product not found (#4)` });
}
const { product } = useProduct(productResponse.value.product, productResponse.value.configurator);
</script>

<template>
	<ProductDetailPage :product="product" />
</template>
